<template>
  <!--页面主体-->
  <div class="g-container container-p">
    <div class="m-container m-width">
      <!--面包屑-->
      <div class="crumbs-box">
        <span class="c-current">匠心记</span>
        <span class="c-sep">&gt;</span>
        <span class="c-current">创建日报</span>
      </div>
      <!--主体-->
      <div class="create-qe-main">
        <h2 class="create-daily-tit">创建日报</h2>
        <div class="create-daily-form">
          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span class="must-mark-p">*&nbsp;</span>
                <span>项目信息</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">项目名称</div>
              <div class="c-daily-info">
                <b>{{title}}</b>
              </div>
            </div>
            <!-- <div class="c-daily-row">
                        <div class="c-daily-label">时间</div>
                        <div class="c-daily-info">
                            <div class="block">
                                <el-date-picker v-model="dateValue"
                                                align="right"
                                                type="date"
                                                placeholder="选择日期"
                                                :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>
                        </div>
            </div>-->
            <div class="c-daily-row">
              <div class="c-daily-label">安全状况</div>
              <div class="c-daily-info">
                <!--选中 +active-->
                <span
                  class="daily-tag-green"
                  :class="{'active':this.form.salfState == '1'}"
                  @click="chooseSafe(1)"
                >安全</span>
                <span
                  class="daily-tag-red"
                  @click="chooseSafe(2)"
                  :class="{'active':this.form.salfState == '2'}"
                >异常</span>
                <span class="cm-red">(*必填)</span>
              </div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">项目负责</div>
              <div class="c-daily-info">
                <p>{{userInfo && userInfo.nickName}}</p>
                <!-- <input
                  class="input"
                  type="text"
                  v-model="projectPartnerString"
                  @blur.prevent="filterprojectPartner"
                  placeholder
                />
                <span class="cm-red">(*必填)</span> -->
              </div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">项目管理</div>
              <div class="c-daily-info">
                <input
                  class="input"
                  type="text"
                  v-model="projectManageString"
                  @blur.prevent="filterprojectManage"
                  placeholder
                />
                <span class="cm-red">(*必填)</span>
              </div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">对策</div>
              <div class="c-daily-info">
                <input class="input" type="text" v-model="form.measure" placeholder />
                <span class="cm-red">(*必填)</span>
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span class="must-mark-p">*&nbsp;</span>
                <span>项目进度</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">详细描述</div>
              <div class="c-daily-info">
                <textarea v-model="form.pschedule" placeholder="请描述一下项目进度......"></textarea>
                <span class="cm-red">(*必填)</span>
              </div>
            </div>

            <div class="c-daily-row">
              <div class="c-daily-label">添加图片</div>
              <div class="c-daily-info upload-img-p">
                <image-upload :src="src" @getDataArr="getDataArr1">
                  <i slot="del" class="del-p"></i>
                  <p slot="limitImg" class="limit-img-p">( *不能少于三张)</p>
                </image-upload>
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span class="must-mark-p">*&nbsp;</span>
                <span>安全汇报</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">详细描述</div>
              <div class="c-daily-info">
                <textarea v-model="form.Security" placeholder="请描述一下安全汇报......"></textarea>
                <span class="cm-red">(*必填)</span>
              </div>
            </div>

            <div class="c-daily-row">
              <div class="c-daily-label">添加图片</div>
              <div class="c-daily-info upload-img-p">
                <image-upload :src="src" @getDataArr="getDataArr2">
                  <i slot="del" class="del-p"></i>
                  <p slot="limitImg" class="limit-img-p">( *不能少于三张)</p>
                </image-upload>
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span class="must-mark-p">*&nbsp;</span>
                <span>人员详情</span>
              </p>
              <div class="line-p"></div>
            </div>

            <div class="c-daily-row">
              <div class="c-daily-label">详细描述</div>
              <div class="c-daily-info">
                <textarea v-model="form.sDetail" placeholder="请描述一下人员详情......"></textarea>
                <!-- <span class="cm-red">(*必填)</span> -->
              </div>
            </div>

            <div class="c-daily-row">
              <div class="c-daily-label">人员人数</div>
              <div class="c-daily-info">
                <span class="pr-20">共</span>
                <input class="short-input input" type="text" v-model="form.peopleNum" placeholder />
                <span class="cm-red">(*必填)</span>
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span class="must-mark-p">*&nbsp;</span>
                <span>本日工作总结</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">总结描述</div>
              <div class="c-daily-info">
                <textarea v-model="form.ThisdayConclusion" placeholder="请描述一下本日工作总结......"></textarea>
                <span class="cm-red">(*必填)</span>
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span>需协调事宜</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">事宜描述</div>
              <div class="c-daily-info">
                <textarea v-model="form.pdiscuss" placeholder="请描述一下协调事宜......"></textarea>
                <!--<span class="cm-red">(*必填)</span>-->
              </div>
            </div>
          </div>

          <div class="daily-p">
            <div class="item-title-p">
              <p>
                <span>其他情况汇报</span>
              </p>
              <div class="line-p"></div>
            </div>
            <div class="c-daily-row">
              <div class="c-daily-label">其他情况汇报</div>
              <div class="c-daily-info">
                <textarea v-model="form.pother" placeholder="请描述一下其他情况汇报......"></textarea>
              </div>
            </div>
          </div>
          <!-- <div class="c-daily-row">
            <div class="c-daily-label">现场图片上传</div>
            <div class="c-daily-info">
              <div class="create-daily-pic">
                <div class="pic-daily-item">
                  <button class="upload-btn">添加图片</button>
                  <input
                    type="file"
                    id="imgFile"
                    name="file"
                    @change="uploadImg()"
                    ref="imgFileInput"
                    accept="image/png, image/jpeg, image/gif, image/jpg"
                  />
                </div>
                <div class="pic-daily-item" v-for="(img,m) in form.imgs" :key="m">
                  <img :src="img" alt />
                  <i class="daily-del-pic" @click="delImg(m)"></i>
                </div>
              </div>
              <span class="cm-red">(*必填)</span>
            </div>
          </div>-->
        </div>
        <div class="cm-form-btn">
          <!-- <div class="cu-form-btn bg-grey">取消</div> -->
          <div class="cu-form-btn" @click="submitFunc()">上传</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../html/components/crumbs/crumbs.scss';

import '../../../../html/pages/originality/createDaily/createDaily.scss';

import imageUpload from "../../../../components/imageUpload/ImageUpload"

import { uploadImage, jxjAddDaily } from '../../../../api/index.js';

import {mapState} from "vuex"

export default {
  name: 'createDaliy.vue',
  data() {
    return {
      title: this.$route.query.title,

      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      },
      dateValue: '',
      projectPartnerString: '',
      projectManageString: '',
      src: require('../../../../html/pages/originality/createDaily/images/upload.jpg'),
      form: {
        id: this.$route.params.id,//项目ID
        projectPartner: [],//项目负责
        projectManage: [],//项目管理
        measure: '',//对策
        salfState: '',//安全状态 1，2
        pdiscuss: '',//需协调事宜
        pschedule: '',//项目进度
        PscheduleImage:[],//项目进度图片
        Security:'',//安全汇报
        SecurityImage:[],//安全汇报图片
        ThisdayConclusion:'',//本日总结
        pother: '',//其他情况汇报
        peopleNum: '',//现场人数
        sDetail: '',//详情
      },
      rules: {
        salfState: [
          { required: true, message: '请选择安全状态!' },
        ],
        projectManage: [
          { required: true, message: '请填写项目管理人!' },
        ],
        measure: [
          { required: true, message: '请填写对策!' },
        ],
        pschedule: [
          { required: true, message: '请填写项目进度!' },
        ],
        Security: [
          { required: true, message: '请填写安全汇报!' },
        ],
        peopleNum: [
          { required: true, message: '请填写现场人数!' },
          { pattern: /^[0-9]+$/, message: '现场人数必须是整数!' }
        ],
        ThisdayConclusion: [
          { required: true, message: '请填写本日工作总结!' },
        ],
      }
      // validate: {
      //     partnerDir: false,
      //     manageDir: false,
      //     measureDir: false,
      //     salfStateDir: false,
      //     pscheduleDir: false,
      // }
    }
  },
  components: {
    imageUpload
  },
  computed:{
    ...mapState(["userInfo"])
  },
  methods: {
    chooseSafe(state) {
      this.form.salfState = state;
      console.log(this.form.salfState);
    },
    delImg(i) {
      this.form.imgs.splice(i, 1);
    },
    //添加现场图片
    async uploadImg() {
      let file = this.$refs.imgFileInput.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(file);
      let that = this;
      reader.onload = async function (e) {
        let res = await uploadImage({
          file: file
        });
        if (res.Type == 'Success') {
          that.form.imgs.push(res.Data);
        }

      };
    },
    filterprojectManage() {
      if (this.projectManageString.length > 0) {
        this.form.projectManage = this.projectManageString.split(',');

      } else {
        this.form.projectManage = [];
      }
      console.log(this.form.projectManage);
    },
    // filterprojectPartner() {
    //   if (this.projectPartnerString.length > 0) {
    //     this.form.projectPartner = this.projectPartnerString.split(',');

    //   } else {
    //     this.form.projectPartner = [];
    //   }
    //   console.log(this.form.projectPartner);
    // },
    async submitFunc() {
      let validator = new this.$validator(this.rules);
      let model = this.form;
      validator.validate(model, async (errors, fields) => {
        if (!errors) {
          if(this.form.PscheduleImage.length < 3){
            return this.$layer.alert("项目进度图片不能少于三张!")
          }
          if(this.form.SecurityImage.length < 3){
            return this.$layer.alert("安全汇报图片不能少于三张!")
          }
          this.form.PscheduleImage = this.form.PscheduleImage.join(",")
          this.form.SecurityImage = this.form.SecurityImage.join(",")
          let res = await jxjAddDaily(this.form);
          if (res.Type == 'Success') {
            this.$layer.msg(res.Content, (msg) => {
              this.$layer.close(msg)
              this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
            })
          }else{
            this.$layer.alert(res.Content)
          }
        } else {
          this.$layer.alert(errors[0].message);
        }
      });
    },
    getDataArr1(data) {
      this.form.PscheduleImage = data
    },
    getDataArr2(data) {
      this.form.SecurityImage = data
    },
  },
  created(){
    this.form.projectPartner.push(this.userInfo.nickName)
  }
}
</script>

<style>
</style>
